import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';

export const quotationEndpoints = {
    'GET /rfqs/:rfqId/quotation': endpoint({
        description: 'Returns the quotation file of a given rfq',
        pathParams: z.object({ rfqId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z
                .object({
                    url: z.string(),
                })
                .nullable(),
        }),
        actionPermission: () => 'CanUploadQuotationFile',
    }),
    'GET /rfqs/:rfqId/quotation/upload': endpoint({
        description: 'Returns an Azure url to upload the quotation file given an rfq',
        pathParams: z.object({ rfqId: z.string() }),
        // Without `replace_existing_quotation: true` the request fails with 409 Conflict
        // when a quotation document already exists.
        queryParams: z.object({ replace_existing_quotation: z.boolean().optional() }),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z.object({
                url: z.string(),
            }),
        }),
        // Uploading a quotation moves an automatic-workflow RfQ to the manual workflow, which changes
        // the flexible calculation's evaluation mode (derived from the RfQ).
        invalidates: ['GET /rfqs/:rfqId/quotation', 'GET /rfqs/:rfqId'],
        actionPermission: () => 'CanUploadQuotationFile',
    }),
    'DELETE /rfqs/:rfqId/quotation': endpoint({
        description: 'Deletes the quotation file given its file name and rfqId',
        pathParams: z.object({ rfqId: z.string() }),
        queryParams: z.object({ blob_name: z.string() }),
        requestBody: z.undefined(),
        responseBody: z.string(),
        invalidates: ['GET /rfqs/:rfqId/quotation'],
        actionPermission: () => 'CanDeleteQuotationFile',
    }),
};
